import React from 'react';
import { useState } from 'react';
import { AppInfo } from './AppInfo';
import { androidMajorVersion, ANDROID_Q_VERSION } from './utils/os';

const HEYTAP_APK =
  'https://iot-heythings-cn.heytapimage.com/heythings-static/resource/apk/SmartHome_heyTap.apk';
const HEYTAP_OUT_APK =
  'https://iot-heythings-cn.heytapimage.com/heythings-static/resource/apk/SmartHome_HeyTapOut.apk';
const O_HOME_APK =
  'https://iot-heythings-cn.heytapimage.com/heythings-static/resource/apk/SmartHome_ohome.apk';

const BrandList = [
  {
    displayName: 'OPPO',
    name: 'oppo'
  },
  {
    displayName: '华为',
    name: 'huawei'
  },
  {
    displayName: '小米',
    name: 'xiaomi'
  },
  {
    displayName: 'vivo',
    name: 'vivo'
  },
  {
    displayName: '三星',
    name: 'samsung'
  },
  {
    displayName: '一加',
    name: 'oneplus'
  },
  {
    displayName: 'Realme',
    name: 'realme'
  },
  {
    displayName: '其他',
    name: 'others'
  }
];

const BrandPicker = ({ onClose }) => {
  const onBrandItemClick = (brandName) => {
    if (typeof brandName === 'undefined') return;
    const selectedBrand = BrandList.find((brand) => brand.name === brandName);
    // 其它手机用heytap out包
    let downloadUrl = HEYTAP_OUT_APK;

    // oppo和realme 10.0以上用 heytap包，否则用ohome包
    if (selectedBrand.name === 'oppo' || selectedBrand.name === 'realme') {
      if (androidMajorVersion >= ANDROID_Q_VERSION) {
        downloadUrl = HEYTAP_APK;
      } else {
        downloadUrl = O_HOME_APK;
      }
    }

    // 一加统一用 heytap包
    if (selectedBrand.name === 'oneplus') {
      downloadUrl = HEYTAP_APK;
    }

    window.location.href = downloadUrl;
    onClose();
  };

  return (
    <>
      <div className="mask"></div>
      <div className="phone-brand-picker">
        <i className="close" onClick={onClose}></i>
        <h3>请选择你的手机品牌</h3>
        <p className="description">
          请选择你当前手机的品牌，下载正确的应用安装包。
        </p>
        <div className="brand-list">
          {BrandList.map((brandInfo) => {
            return (
              <span
                className="brand-item"
                key={brandInfo.name}
                onClick={() => onBrandItemClick(brandInfo.name)}>
                {brandInfo.displayName}
              </span>
            );
          })}
        </div>
      </div>
    </>
  );
};

export const AndroidPage = () => {
  const [brandPickerVisibility, setBrandPickerVisibility] = useState(false);
  return (
    <div className="android-download-page">
      <AppInfo />
      {brandPickerVisibility && (
        <BrandPicker onClose={() => setBrandPickerVisibility(false)} />
      )}
      <div className="footer">
        <p className="remarks">
          “智能家居”，“heytap智能家居”和“欢太智能家居”为同一APP在不同平台的名称，请放心下载。
        </p>
        <div
          className="btn-download"
          onClick={() => setBrandPickerVisibility(true)}>
          立即下载
        </div>
      </div>
    </div>
  );
};
